import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Bell } from "lucide-react";

export default function NotificationsPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/notifications/my").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);
  const markAll = async () => {
    await api.put("/notifications/read-all");
    const r = await api.get("/notifications/my");
    setItems(r.data);
  };
  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-8">
      <div className="flex items-center justify-between mb-4">
        <h1 className="font-fredoka text-3xl font-bold flex items-center gap-2" data-testid="notif-page-title"><Bell strokeWidth={2.5}/> Notifications</h1>
        <button onClick={markAll} className="btn-push-outline px-3 py-1.5 text-xs" data-testid="notif-page-markall">Mark all read</button>
      </div>
      {loading ? <div className="text-slate-500">Loading…</div> : items.length === 0 ? (
        <div className="card-clay p-8 text-center text-slate-400">No notifications yet</div>
      ) : (
        <div className="card-clay divide-y divide-slate-100" data-testid="notif-page-list">
          {items.map((n) => (
            <div key={n.id} className={`px-5 py-4 ${!n.read ? "bg-amber-50/40" : ""}`} data-testid={`notif-page-item-${n.id}`}>
              <div className="font-semibold text-slate-800">{n.title}</div>
              {n.body && <div className="text-sm text-slate-600 mt-1">{n.body}</div>}
              <div className="text-[10px] uppercase font-bold tracking-wider text-slate-400 mt-1">{new Date(n.created_at).toLocaleString()}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
